export { UnlinkInsuree as default } from './unlink-insuree';
